import { NavbarMenu } from '@root/core/interfaces';

export const ADMIN_SELLER_API_MENU: NavbarMenu[] = [
  {
    id: 1,
    name: 'Warehouse',
    url: '/admin/seller-api/warehouse'
  },
  {
    id: 1,
    name: 'Quotataion',
    url: '/admin/seller-api/quotation'
  },
  {
    id: 1,
    name: 'Import',
    url: '/admin/seller-api/import'
  },
  {
    id: 1,
    name: 'Product',
    url: '/admin/seller-api/product'
  },
  {
    id: 1,
    label: 'Order',
    children: [
      { name: 'return', url: '/admin/seller-api/order/return' },
      { name: 'normal', url: '/admin/seller-api/order/normal' }
    ]
  }
];
